import React, { FunctionComponent, ReactNode } from 'react'
import PuxButton from 'Shared/components/PuxButton/PuxButton'
import { t } from 'ttag'

import { PricingPlan } from './pricingPlans'
import { PricingHosting } from './pricingTypes'

interface PlansTablePlanHeaderProps {
  children?: ReactNode
  hosting: PricingHosting
  onEnterpriseClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  plan: PricingPlan
}

const PlansTablePlanHeader: FunctionComponent<PlansTablePlanHeaderProps> = ({
  children,
  hosting,
  onEnterpriseClick,
  plan,
}) => {
  const onPremises = hosting === `on-premises`
  const contactSales = onPremises || plan.enterprise
  const cloudButtonText = plan.enterprise
    ? t`Redmine.Pricing.LetsTalk`
    : t`Redmine.Pricing.TryIt`

  return (
    <div
      className={`PlansTable-plan-header PlansTable-plan-header--${plan.id.toLowerCase()}${
        plan.highlighted ? ` PlansTable-plan-header--highlighted` : ``
      }`}
    >
      {plan.highlighted ? (
        <div className='PlansTable-sticker'>
          <span>{t`Redmine.Pricing.MostPopular`}</span>
        </div>
      ) : null}
      <div className='PlansTable-price'>
        <h4>{plan.title}</h4>
        <div className='PlansTable-price-inner'>
          {plan.enterprise ? (
            <>
              <a
                className='PlansTable-price-value PlansTable-price-value--text'
                data-open-modal-id='talk'
                onClick={onEnterpriseClick}
              >{t`Redmine.Pricing.Enterprice.ContactUs`}</a>
              <p
                className='PlansTable-amount PlansTable-perpetual'
                aria-hidden={!onPremises}
              >{t`Redmine.Pricing.Enterprice.PerpetualPricing`}</p>
            </>
          ) : (
            children
          )}
        </div>
        <PuxButton
          buttonType={plan.highlighted ? `primary` : `border`}
          buttonSize='medium'
          buttonLink={{
            url: [contactSales ? `/` : `#trial`],
            internal: [contactSales],
            text: [
              onPremises ? t`Redmine.Header.ContactSales` : cloudButtonText,
            ],
          }}
          buttonOpenModalId={contactSales ? `talk` : undefined}
        />
      </div>
    </div>
  )
}

export default PlansTablePlanHeader
